import { NAV_HUBS, TOOL_NAV_ITEMS } from './workbenchNavConfig';

/** 采集/详情快捷联动工具栏：不展示的模块 */
export const SOURCING_TOOL_BRIDGE_EXCLUDE_NAV_IDS = new Set([
  'imageCollection',
  'sourcingHub',
  'thirdPartyReceive',
  /** 图生视频 / 文生视频：详情页不接入快捷工具栏，也不作为联动目标 */
  'videos',
  'textToVideo',
  /** 文生图：以文字提示词生成，无法使用已选图片作为输入 */
  'aiTextToImage',
]);

/**
 * 允许通过快捷功能写入「商品库」的来源模块：
 * 商品设计 / 主图创作 / 素材采集 / AI文案 / 第三方任务
 */
export const PLATFORM_LISTING_QUICK_BRIDGE_SOURCE_NAV_IDS = new Set([
  'podProductDesign',
  'goods',
  'imageCollection',
  'sourcingHub',
  'aiCopywriting',
  /** 第三方任务：选中入库结果后可直接带入商品库复色 */
  'thirdPartyReceive',
  /** 兼容旧标题提取深链 */
  'titles',
]);

/** 商品库页快捷联动仅开放的目标模块 */
export const PLATFORM_LISTING_QUICK_BRIDGE_TARGET_NAV_IDS = [
  'podProductDesign',
  'goods',
  'imageCollection',
  'aiCopywriting',
];

/** POD 刊登相关：非白名单来源详情页需从快捷栏隐藏 */
export const PLATFORM_LISTING_QUICK_BRIDGE_NAV_IDS = new Set([
  'platformListing',
  'platformListingJobs',
]);

export function canUsePlatformListingQuickBridge(sourceNavId) {
  return PLATFORM_LISTING_QUICK_BRIDGE_SOURCE_NAV_IDS.has(String(sourceNavId || '').trim());
}

/** 智能工具 Hub 分组 → 采集详情联动工具栏配置 */
export const SOURCING_TOOL_BRIDGE_GROUPS = (NAV_HUBS.aiTools?.sections || [])
  .map((section) => ({
    id: section.title,
    label: section.title,
    items: (section.items || [])
      .filter((navId) => !SOURCING_TOOL_BRIDGE_EXCLUDE_NAV_IDS.has(navId))
      .map((navId) => TOOL_NAV_ITEMS[navId])
      .filter(Boolean),
  }))
  .filter((group) => group.items.length > 0);

/**
 * 按当前详情页 navId 过滤工具栏分组：处于某功能详情时隐藏该功能入口；
 * 非白名单来源额外隐藏「商品库」快捷入口。
 * @param {string|string[]|Set<string>} excludeNavIds
 * @param {{ sourceNavId?: string, allowPlatformListing?: boolean }} [options]
 */
export function filterSourcingToolBridgeGroups(excludeNavIds, options = {}) {
  const exclude = excludeNavIds instanceof Set
    ? new Set(excludeNavIds)
    : new Set(
      Array.isArray(excludeNavIds)
        ? excludeNavIds
        : [excludeNavIds].filter(Boolean).map(String),
    );
  const allowListing = options.allowPlatformListing === true
    || canUsePlatformListingQuickBridge(options.sourceNavId);
  if (!allowListing) {
    PLATFORM_LISTING_QUICK_BRIDGE_NAV_IDS.forEach((id) => exclude.add(id));
  }
  if (exclude.size === 0) return SOURCING_TOOL_BRIDGE_GROUPS;
  return SOURCING_TOOL_BRIDGE_GROUPS
    .map((group) => ({
      ...group,
      items: (group.items || []).filter((item) => item?.id && !exclude.has(item.id)),
    }))
    .filter((group) => group.items.length > 0);
}

/** 商品库场景：仅展示商品设计 / 主图创作 / 素材采集 / AI文案 */
export function getPodToolBridgeGroups() {
  const items = PLATFORM_LISTING_QUICK_BRIDGE_TARGET_NAV_IDS
    .map((navId) => TOOL_NAV_ITEMS[navId])
    .filter(Boolean);
  return items.length > 0
    ? [{ id: 'pod', label: '', items }]
    : [];
}
